<template>
  <div class="layout-content-list batch-update-freight">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>批量修改运费</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 货源管理列表 </span>
      </div>
      <div class="fr">
        <el-button @click="handleSubmit" type="primary" :disabled="stockList.length == 0" class="fr">提交</el-button>
        <el-button @click="handleReset" type="primary" class="fr mr-10">重置</el-button>
      </div>
    </div>

    <div class="search-box toolbar-panel">
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">计划运费1（元/吨）</span>
        <el-input v-model.trim="defaultData.stockUnitPrice1" style="width: 170px" placeholder="请输入"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">运费1生效时间</span>
        <date-picker
          placeholder="请选择生效时间"
          v-model="defaultData.planTime1"
          type="datetime"
          value-type="timestamp"
          appendToBody
          :disabled-date="notBeforeToday"
          :disabled-time="notBeforeNow"
          :confirm="false"
          confirm-text="确认"
          format="YYYY-MM-DD HH:mm"
          width="170"
          :time-picker-options="{ start: '00:00', step: '00:10', end: '23:50' }"
          :editable="false"
        ></date-picker>
      </div>
      <div class="toolbar-item tip-box" id="auto-2">
        <span class="item-label">计划运费2（元/吨）</span>
        <el-input v-model.trim="defaultData.stockUnitPrice2" style="width: 170px" placeholder="请输入"> </el-input>
        <span class="tip">运费1生效时间为空时，提交后立即生效</span>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">运费2生效时间</span>
        <date-picker
          placeholder="请选择生效时间"
          v-model="defaultData.planTime2"
          type="datetime"
          value-type="timestamp"
          appendToBody
          :disabled-date="notBeforeToday"
          :disabled-time="notBeforeNow"
          :confirm="false"
          confirm-text="确认"
          format="YYYY-MM-DD HH:mm"
          width="170"
          :time-picker-options="{ start: '00:00', step: '00:10', end: '23:50' }"
          :editable="false"
        ></date-picker>
      </div>
      <div class="toolbar-item" id="auto-2">
        <el-button @click="handleSetData" type="primary">批量修改</el-button>
      </div>
    </div>

    <div class="table-custom-box">
      <el-table :data="stockList" border>
        <el-table-column label="企业名称" width="160" prop="companyName" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="装货地-卸货地" width="100" prop="stockName" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="loadName" label="装货地址名称" min-width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="unloadName" label="卸货地址名称" min-width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="煤种" min-width="60" prop="stockKindName"> </el-table-column>
        <el-table-column label="当前运费" min-width="100" prop="currentPrice"></el-table-column>
        <template v-if="supportDeliveryPricing">
          <el-table-column label="亏扣单价" prop="currentLossUnitPrice" min-width="120">
            <template v-slot="scope">
              {{ scope.row.currentLossUnitPrice }}
            </template>
          </el-table-column>
        </template>

        <el-table-column label="计划运费1（元/吨）" min-width="130" key="stockUnitPrice0">
          <template v-slot="scope">
            <el-input v-model.trim="scope.row.list[0].stockUnitPrice" />
          </template>
        </el-table-column>
        <template v-if="supportDeliveryPricing">
          <el-table-column label="亏扣单价1（元/吨）" width="130" key="lossUnitPrice0">
            <template v-slot="scope">
              <el-input
                v-if="scope.row.supportDeliveryPricing"
                v-model.trim="scope.row.list[0].lossUnitPrice"
                :disabled="!scope.row.currentLossUnitPrice"
              />
              <span v-else>未配置，不可修改</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="生效时间" width="250" key="planTime0">
          <template v-slot="scope">
            <date-picker
              placeholder="请选择生效时间"
              v-model="scope.row.list[0].planTime"
              type="datetime"
              value-type="timestamp"
              appendToBody
              :disabled-date="notBeforeToday"
              :disabled-time="notBeforeNow"
              :confirm="false"
              confirm-text="确认"
              format="YYYY-MM-DD HH:mm"
              width="170"
              :time-picker-options="{ start: '00:00', step: '00:10', end: '23:50' }"
              :editable="false"
            ></date-picker>
          </template>
        </el-table-column>
        <el-table-column label="计划运费2（元/吨）" min-width="130" key="stockUnitPrice1">
          <template v-slot="scope">
            <el-input v-model.trim="scope.row.list[1].stockUnitPrice" />
          </template>
        </el-table-column>
        <template v-if="supportDeliveryPricing">
          <el-table-column label="亏扣单价2（元/吨）" width="130" key="lossUnitPrice1">
            <template v-slot="scope">
              <el-input
                v-if="scope.row.supportDeliveryPricing"
                v-model.trim="scope.row.list[1].lossUnitPrice"
                :disabled="!scope.row.currentLossUnitPrice"
              />
              <span v-else>未配置，不可修改</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="生效时间" width="250" key="planTime1">
          <template v-slot="scope">
            <date-picker
              placeholder="请选择生效时间"
              v-model="scope.row.list[1].planTime"
              type="datetime"
              value-type="timestamp"
              appendToBody
              :disabled-date="notBeforeToday"
              :disabled-time="notBeforeNow"
              :confirm="false"
              confirm-text="确认"
              format="YYYY-MM-DD HH:mm"
              width="170"
              :time-picker-options="{ start: '00:00:00', step: '00:10', end: '23:50:00' }"
              :editable="false"
            ></date-picker>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :visible.sync="updateFreightStatus" custom-class="dia-tiny">
      <div class="font-size18">运费修改成功</div>
      <div v-if="effectiveTime" class="mt-20">
        <span class="effective-ico"> <img src="../../assets/img/passport/ic_success.png" alt="" /></span>
        计划运费1已生效，生效时间：<span class="font-green">{{ effectiveTime }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="updateFreightStatus = false">重新修改</el-button>
        <el-button type="primary" @click="handleBack">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import calc from '@fe/calc';
import { isNumber, isInt } from '@fe/validator';
const today = new Date();
today.setHours(0, 0, 0, 0);
// const stockUnitPriceReg = /(^[1-9]\d*$)/;
// const lossUnitPriceReg = /^[1-9]\d*(\.\d{1,2})?$/;
export default {
  name: 'BatchUpdateFreight',
  data() {
    return {
      // stockUnitPriceReg,
      // lossUnitPriceReg,
      value: '',
      batchId: 0,
      stockList: [],
      maxmoney: WUYI.getCompanyConfig.freightLimit,
      defaultData: {
        stockUnitPrice1: '',
        planTime1: null,
        stockUnitPrice2: null,
        planTime2: ''
      },
      updateFreightStatus: false,
      supportDeliveryPricing: false, // 是否支持发货定价
      effectiveTime: ''
    };
  },
  components: {
    DatePicker
  },
  created() {
    this.batchId = this.$route.params.key;
    this.axiosRequest();
  },
  methods: {
    handleReset() {
      this.defaultData = {
        stockUnitPrice1: '',
        planTime1: null,
        stockUnitPrice2: null,
        planTime2: ''
      };
      this.axiosRequest();
    },
    // 根据批次号查询货源列表
    axiosRequest() {
      axios.post(api.qryStockPricePublish, { batchId: this.batchId }).then(res => {
        this.supportDeliveryPricing = res.data.supportDeliveryPricing;
        this.stockList = res.data.stockPriceDataRsps;
        for (let i = 0; i < this.stockList.length; i++) {
          for (let j = 0; j < this.stockList[i].list.length; j++) {
            if (!this.stockList[i].list[j].planTime) {
              this.stockList[i].list[j].planTime = null;
            }
            if (this.stockList[i].list[j].lossUnitPrice == 0) {
              this.stockList[i].list[j].lossUnitPrice = '';
            }
          }
        }
      });
    },
    notBeforeToday(date) {
      return date < today;
    },
    notBeforeNow(date) {
      return date < Date.now();
    },
    // 批量修改
    handleSetData() {
      if (!isNull(this.defaultData.stockUnitPrice1) && !isInt(this.defaultData.stockUnitPrice1, false)) {
        this.$message.error(`计划运费1格式错误，请重试`);
        return;
      }
      if (!isNull(this.defaultData.stockUnitPrice2) && !isInt(this.defaultData.stockUnitPrice2, false)) {
        this.$message.error(`计划运费2格式错误，请重试`);
        return;
      }
      if (this.defaultData.planTime1 && this.defaultData.planTime1 < Date.now()) {
        this.$message.error(`计划运费1生效时间需晚于当前时间`);
        return;
      }
      if (this.defaultData.planTime2 && this.defaultData.planTime2 < Date.now()) {
        this.$message.error(`计划运费2生效时间需晚于当前时间`);
        return;
      }
      if (
        this.defaultData.planTime1 &&
        this.defaultData.planTime2 &&
        this.defaultData.planTime2 <= this.defaultData.planTime1
      ) {
        this.$message.error(`计划运费2生效时间需晚于计划运费1的生效时间 `);
        return;
      }
      for (let i = 0; i < this.stockList.length; i++) {
        let stockUnitPrice1 = this.stockList[i].list[0].stockUnitPrice;
        let planTime1 = this.stockList[i].list[0].planTime;
        let stockUnitPrice2 = this.stockList[i].list[1].stockUnitPrice;
        let planTime2 = this.stockList[i].list[1].planTime;

        this.stockList[i].list[0].stockUnitPrice = this.defaultData.stockUnitPrice1
          ? this.defaultData.stockUnitPrice1
          : stockUnitPrice1;

        this.stockList[i].list[1].stockUnitPrice = this.defaultData.stockUnitPrice2
          ? this.defaultData.stockUnitPrice2
          : stockUnitPrice2;

        this.stockList[i].list[0].planTime = this.defaultData.planTime1 ? this.defaultData.planTime1 : planTime1;
        this.stockList[i].list[1].planTime = this.defaultData.planTime2 ? this.defaultData.planTime2 : planTime2;
      }
    },
    // 支持亏扣单价验证
    validSupportPrice(item, i) {
      let currentLossUnitPrice = item.currentLossUnitPrice; // 当前的亏扣单价
      let stockCount = item.stockCount; // 发货数量
      let stockUnitPrice1 = item.list[0].stockUnitPrice; // 计划运费
      let lossUnitPrice1 = item.list[0].lossUnitPrice; // 亏扣单价
      let planTime1 = item.list[0].planTime; // 生效时间

      let stockUnitPrice2 = item.list[1].stockUnitPrice;
      let lossUnitPrice2 = item.list[1].lossUnitPrice;
      let planTime2 = item.list[1].planTime;
      // 都没填
      if (
        isNull(stockUnitPrice1) &&
        isNull(lossUnitPrice1) &&
        !planTime1 &&
        isNull(stockUnitPrice2) &&
        isNull(lossUnitPrice2) &&
        !planTime2
      ) {
        this.$message.error(`第${i + 1}行已勾选的线路未填写价格，请填写价格`);
        return false;
      }

      if (currentLossUnitPrice) {
        // 计划1 时间选了 运费和亏扣单价都没填
        if (isNull(stockUnitPrice1) && isNull(lossUnitPrice1) && planTime1) {
          this.$message.error(`第${i + 1}行计划运费1或亏扣单价1不能为空`);
          return false;
        }
      } else {
        if (isNull(stockUnitPrice1) && planTime1) {
          this.$message.error(`第${i + 1}行计划运费1不能为空`);
          return false;
        }
      }
      // 填了计划2 计划运费1运费和亏扣单价都没填
      if (currentLossUnitPrice) {
        if (
          (!isNull(stockUnitPrice2) || !isNull(lossUnitPrice2)) &&
          planTime2 &&
          isNull(stockUnitPrice1) &&
          isNull(lossUnitPrice1)
        ) {
          this.$message.error(`第${i + 1}行计划运费1或亏扣单价1不能为空`);
          return false;
        }
      } else {
        if (!isNull(stockUnitPrice2) && planTime2 && isNull(stockUnitPrice1)) {
          this.$message.error(`第${i + 1}行计划运费1不能为空`);
          return false;
        }
      }

      if (!isNull(stockUnitPrice1) && !isInt(stockUnitPrice1, false)) {
        this.$message.error(`第${i + 1}行计划运费1格式错误，请重试`);
        return false;
      }

      if (currentLossUnitPrice && !isNull(lossUnitPrice1) && !isNumber(lossUnitPrice1, false, 2)) {
        this.$message.error(`第${i + 1}行计划亏扣单价1格式错误，请重试`);
        return false;
      }
      // 计划1 单价太大
      if (!isNull(stockUnitPrice1) && isOverMax(calc.multiply(stockCount, stockUnitPrice1))) {
        this.$message.error(`第${i + 1}行计划运费1运费总额超过最大值，请重新输入`);
        return false;
      }
      // 计划1 时间 早于当前时间
      if (planTime1 && planTime1 < Date.now()) {
        this.$message.error(`第${i + 1}行计划1生效时间需晚于当前时间`);
        return false;
      }

      // 计划2 时间选了 运费和亏扣单价都没填
      if (currentLossUnitPrice) {
        if (isNull(stockUnitPrice2) && isNull(lossUnitPrice2) && planTime2) {
          this.$message.error(`第${i + 1}行计划运费2或亏扣单价不能为空`);
          return false;
        }
      } else {
        if (isNull(stockUnitPrice2) && planTime2) {
          this.$message.error(`第${i + 1}行计划运费2不能为空`);
          return false;
        }
      }

      // 计划2 运费或亏扣单价至少填了一个, 时间没选
      if ((!isNull(stockUnitPrice2) && !planTime2) || (!isNull(lossUnitPrice2) && !planTime2)) {
        this.$message.error(`第${i + 1}行计划运费2生效时间不能为空`);
        return false;
      }

      if (!isNull(stockUnitPrice2) && !isInt(stockUnitPrice2, false)) {
        this.$message.error(`第${i + 1}行计划运费2格式错误，请重试`);
        return false;
      }
      if (currentLossUnitPrice && !isNull(lossUnitPrice2) && !isNumber(lossUnitPrice2, false, 2)) {
        this.$message.error(`第${i + 1}行计划亏扣单价2格式错误，请重试`);
        return false;
      }
      // 计划2 单价太大
      if (!isNull(stockUnitPrice2) && isOverMax(calc.multiply(stockCount, stockUnitPrice2))) {
        this.$message.error(`第${i + 1}行计划运费2运费总额超过最大值，请重新输入`);
        return false;
      }
      // 计划2 时间 早于当前时间
      if (planTime2 && planTime2 < Date.now()) {
        this.$message.error(`第${i + 1}行计划2生效时间需晚于当前时间`);
        return false;
      }
      // 计划2 和计划1 时间都选了, 计划2时间 早于计划1时间
      if (planTime1 && planTime2 && planTime2 <= planTime1) {
        this.$message.error(`第${i + 1}行计划运费2生效时间需晚于计划运费1的生效时间 `);
        return false;
      }
      return true;
    },
    // 不支持亏扣单价验证
    validNotSupportPrice(item, i) {
      let stockCount = item.stockCount; // 发货数量
      let stockUnitPrice1 = item.list[0].stockUnitPrice; // 计划运费
      let planTime1 = item.list[0].planTime; // 生效时间

      let stockUnitPrice2 = item.list[1].stockUnitPrice;
      let planTime2 = item.list[1].planTime;

      // 都没填
      if (isNull(stockUnitPrice1) && !planTime1 && isNull(stockUnitPrice2) && !planTime2) {
        this.$message.error(`第${i + 1}行已勾选的线路未填写价格，请填写价格`);
        return false;
      }

      // 计划1 时间选了 运费没填
      if (isNull(stockUnitPrice1) && planTime1) {
        this.$message.error(`第${i + 1}行计划运费1不能为空`);
        return false;
      }

      // 填了计划2 计划运费1运费和亏扣单价都没填
      if (!isNull(stockUnitPrice2) && planTime2 && isNull(stockUnitPrice1)) {
        this.$message.error(`第${i + 1}行计划运费1不能为空`);
        return false;
      }

      if (!isNull(stockUnitPrice1) && !isInt(stockUnitPrice1, false)) {
        this.$message.error(`第${i + 1}行计划运费1格式错误，请重试`);
        return false;
      }

      // 计划1 单价太大
      if (!isNull(stockUnitPrice1) && isOverMax(calc.multiply(stockCount, stockUnitPrice1))) {
        this.$message.error(`第${i + 1}行计划运费1运费总额超过最大值，请重新输入`);
        return false;
      }
      // 计划1 时间 早于当前时间
      if (planTime1 && planTime1 < Date.now()) {
        this.$message.error(`第${i + 1}行计划1生效时间需晚于当前时间`);
        return false;
      }

      // 计划2 时间选了 运费没填
      if (isNull(stockUnitPrice2) && planTime2) {
        this.$message.error(`第${i + 1}行计划运费2不能为空`);
        return false;
      }
      // 计划2 运费填了, 时间没选
      if (!isNull(stockUnitPrice2) && !planTime2) {
        this.$message.error(`第${i + 1}行计划运费2生效时间不能为空`);
        return false;
      }

      if (!isNull(stockUnitPrice2) && !isInt(stockUnitPrice2, false)) {
        this.$message.error(`第${i + 1}行计划运费2格式错误，请重试`);
        return false;
      }
      // 计划2 单价太大
      if (!isNull(stockUnitPrice2) && isOverMax(calc.multiply(stockCount, stockUnitPrice2))) {
        this.$message.error(`第${i + 1}行计划运费2运费总额超过最大值，请重新输入`);
        return false;
      }
      // 计划2 时间 早于当前时间
      if (planTime2 && planTime2 < Date.now()) {
        this.$message.error(`第${i + 1}行计划2生效时间需晚于当前时间`);
        return false;
      }
      if (planTime1 && planTime2 && planTime2 <= planTime1) {
        this.$message.error(`第${i + 1}行计划运费2生效时间需晚于计划运费1的生效时间 `);
        return false;
      }
      return true;
    },
    handleSubmit() {
      let stockList = this.stockList;
      let isValid = true;
      for (let i = 0; i < stockList.length; i++) {
        if (stockList[i].supportDeliveryPricing) {
          isValid = this.validSupportPrice(stockList[i], i);
        } else {
          isValid = this.validNotSupportPrice(stockList[i], i);
        }
        if (!isValid) break;
      }
      if (isValid) {
        this.submitData();
      }
    },
    submitData() {
      let arr = this.stockList.map(item => {
        return {
          companyCode: item.companyCode,
          stockCode: item.stockCode,
          stockPrices: item.list,
          stockCount: item.stockCount
        };
      });
      axios
        .post(api.stockPriceEdit, {
          stockPriceDataList: arr
        })
        .then(res => {
          this.effectiveTime = res.data;
          this.updateFreightStatus = true;
        });
    },
    handleBack() {
      this.$router.go(-1);
    }
  }
};

function isOverMax(val) {
  return val > parseFloat(WUYI.getCompanyConfig.freightLimit);
}
function isNull(val) {
  return val == null || val == '' || typeof val == 'undefined';
}
</script>
<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>
<style lang="postcss">
.batch-update-freight {
  .tip-box {
    position: relative;
    .tip {
      position: absolute;
      left: -48px;
      top: -27px;
      width: 265px;
      height: 34px;
      background: url(../../assets/img/stock/pic_plxgbg.png) no-repeat;
      background-size: 265px 34px;
      color: #e6a23b;
      padding: 2px 0 0 8px;
    }
  }
  .effective-ico {
    display: inline-block;
    width: 23px;
    height: 23px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
